import BaseHeader from '@bnnvara/headers';
import PropTypes from 'prop-types';
import React from 'react';

import broadcasterLogoSelector from '../../helpers/broadcasterLogoSelector';
import resizeImageSource, {
  resizeImageSourceMax,
} from '../../helpers/resizeImageSource';
import useSharedRef from '../../hooks/useSharedRef';
import Link from '../Link';
import extractTitlesFromTagLine from './helpers/extractTitlesFromTagLine';

const Header = ({
  title,
  description,
  titleTagline,
  tagline,
  broadcasters,
  slug,
  backgroundImageUrl,
  backgroundImageMobileUrl,
  bgVideoTeaser,
  logoUrl,
  callToAction,
  url,
  facebook,
  instagram,
  twitter,
  youtube,
  ...props
}) => {
  const mobileImage = backgroundImageMobileUrl || backgroundImageUrl;
  const [subtitle, secondSubtitle] = extractTitlesFromTagLine(tagline);
  const { createRef } = useSharedRef();
  const ref = createRef('brandHeader');
  return (
    <BaseHeader
      ref={ref}
      title={title && title}
      titleTagline={titleTagline && titleTagline}
      subtitle={subtitle && subtitle}
      secondSubtitle={secondSubtitle && secondSubtitle}
      description={description}
      broadcaster={broadcasters && broadcasters[0]}
      broadcasterLogo={broadcasters && broadcasterLogoSelector(broadcasters[0])}
      secondBroadcaster={broadcasters && broadcasters[1]}
      secondBroadcasterLogo={
        broadcasters && broadcasterLogoSelector(broadcasters[1])
      }
      bgVideoTeaser={bgVideoTeaser}
      LinkComponent={Link}
      linkComponentProps={{
        link: `/${slug}`,
      }}
      image={resizeImageSourceMax(backgroundImageUrl)}
      mobileImage={resizeImageSource(mobileImage, 480)}
      brandLogo={resizeImageSource(logoUrl, 120)}
      color="white"
      buttonText={callToAction && callToAction.text}
      buttonUrl={callToAction && callToAction.url}
      socialText="VOLG ONS"
      facebook={facebook}
      instagram={instagram}
      twitter={twitter}
      youtube={youtube}
      {...props}
    />
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  descriptionNotification: PropTypes.node,
  titleTagline: PropTypes.string,
  tagline: PropTypes.string,
  broadcasters: PropTypes.arrayOf(PropTypes.string),
  slug: PropTypes.string,
  backgroundImageUrl: PropTypes.string,
  backgroundImageMobileUrl: PropTypes.string,
  bgVideoTeaser: PropTypes.shape({
    url: PropTypes.string,
  }),
  logoUrl: PropTypes.string,
  callToAction: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string,
  }),
  url: PropTypes.string,
  facebook: PropTypes.string,
  instagram: PropTypes.string,
  twitter: PropTypes.string,
  youtube: PropTypes.string,
};

Header.defaultProps = {
  description: null,
  descriptionNotification: null,
  titleTagline: null,
  tagline: null,
  broadcasters: null,
  slug: null,
  backgroundImageUrl: null,
  backgroundImageMobileUrl: null,
  logoUrl: null,
  callToAction: null,
  url: null,
  facebook: null,
  instagram: null,
  twitter: null,
  youtube: null,
};

export default Header;
